export default __webpack_public_path__ + "static/media/horizontal-logo.07557395.webp";